"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormeJuridiqueTrads = void 0;
exports.EFormeJuridiqueTrads = {
    auto_entrepreneur: "Auto-entrepreneur",
    EI: "EI - Entreprise individuelle",
    EURL: "EURL - Entreprise Unipersonnelle à Responsabilité Limitée",
    SA: "SA - Société Anonyme",
    SARL: "SARL - Société à Responsabilité Limitée",
    SAS: "SAS - Société par Actions Simplifiée",
    SASU: "SASU - Société par Actions Simplifiée Unipersonnelle",
    other: "Autre",
};
